<template>
  <div class="lke-bg" v-loading="loading">
    <div class="lke-top">
      <div class="lke-top-title">
        <i class="el-icon-s-home"></i>
        <span>当前位置:</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <router-link to="/" style="text-decoration: none">
              <el-link>首页</el-link>
            </router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <router-link to="/msfcList" style="text-decoration: none">
              <el-link style="cursor: pointer" type="info">名师</el-link>
            </router-link>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="lke-text-bg">
      <div class="lke-text-tit">名师风采</div>
      <div class="lke-text">
        <div class="lke-text-l">
          <img :src="url + info.img" alt="" />
        </div>
        <div class="lke-text-r">
          <div class="lke-text-r-top">
            {{ info.title }}
          </div>
          <div class="lke-text-r-fot lke-msfc-img" v-html="info.content"></div>
        </div>
      </div>
      <div class="lke-text-fot">
        <!-- <p>上一篇:<span>没有了</span></p>
                <p>下一篇:<span>没有了</span></p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getImgUrl } from "@/utils/auth";
import { getnoticeOne } from "@/api/index";
import moment from "moment";
export default {
  props: {},
  data() {
    return {
      id: "",
      info: {},
      loading: false,
      url: getImgUrl(),
    };
  },
  filters: {
    addtime(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  computed: {},
  created() {
    this.id = this.$route.params.id;
    this.getInfo();
  },
  mounted() {},
  watch: {},
  methods: {
    getInfo() {
      this.loading = true;
      getnoticeOne(this.id).then((response) => {
        this.info = response;
      });
      this.loading = false;
    },
  },
  components: {},
};
</script>

<style>
.lke-msfc-img img {
  display: none;
}
</style>

<style scoped>
::v-deep.lke-text-r-fot img {
  max-width: 100% !important;
}
.lke-text-r-fot img {
  max-width: 100% !important;
}
.lke-bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* padding-bottom: 60px; */
}
.lke-top {
  width: 944px;
  padding: 20px 40px;
}
.lke-top-title {
  display: flex;
  align-items: center;
  font-size: 14px;
}
.lke-top-title > i {
  color: #2890f4;
  font-size: 20px;
}
.lke-top-title > span {
  margin-left: 5px;
  margin-right: 10px;
}
.lke-text-bg {
  width: 904px;
  margin: 0 40px;
  padding: 20px;
  background: #fff;
}
.lke-text-tit {
  padding-bottom: 20px;
  padding: 20px;
  background: #2890f4;
  font-size: 20px;
  letter-spacing: 1px;
  color: #fff;
  font-weight: bold;
}
.lke-text {
  display: flex;
  padding-top: 20px;
  margin-top: 20px;
  border-top: 1px dashed #c0bbc2;
}
.lke-text-l {
  width: 200px;
  height: 200px;
  border: 1px solid #2890f4;
  padding: 10px;
}
.lke-text-l > img {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.lke-text-r {
  padding-left: 20px;
  flex: 1;
}
.lke-text-r-top {
  line-height: 40px;
  border-bottom: 1px dashed #c0bbc2;
  font-size: 20px;
  color: #5c5f5c;
}
.lke-text-r-fot {
  padding-top: 20px;
}
.lke-text-fot {
  font-size: 14px;
  padding: 30px 20px;
}
.lke-text-fot > p {
  line-height: 300%;
  color: #c92748;
}
.lke-text-fot > p span {
  padding-left: 10px;
  color: #5d5c5b;
  cursor: pointer;
}
.lke-text-fot > p span:hover {
  color: #ec6f00;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/msfc/msfc.vue